import { Component, OnInit } from '@angular/core';
import { PagedResponse } from '@shared/models/paged-response';
import { debounceTime, distinctUntilChanged, finalize } from 'rxjs/operators';
import { FormControl } from '@angular/forms';
import { PageEvent } from '@shared/models/page-event';
import { Dealer } from '@shared/models/dealer';
import Utils from '@shared/utils/utils';
import { ApiService } from '@shared/apis';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { SpinnerService } from '@shared/services/spinner.service';
import { UserService } from '@routes/users/shared/user.service';
import { Subject } from 'rxjs';
import { AuthService } from '@core/auth/auth.service';

@Component({
  selector: 'app-assign-dealer',
  templateUrl: './assign-dealer.component.html',
  styleUrls: ['./assign-dealer.component.scss']
})
export class AssignDealerComponent implements OnInit {

  userInfo: any;
  // dealers: any;
  assignedDealers: any;
  unAssignedDealers: any;

  options = { autoHide: true, scrollbarMaxSize: 100 };

  /** assign and unassign buttons */
  assign: any;
  assignedList: any[] = [];
  unassignedList: any[] = [];
  unAssign: any;
  sample: any;

  dealerData!: Dealer[];
  selectedData: Dealer;

  query: any;
  q: any;
  pagedResponse: PagedResponse;
  searchText = new FormControl(null);

  parentSelector: boolean = false;

  public onClose: Subject<any> = new Subject();
  dealerSelectGroup!: Dealer[];

  constructor(
    private apiService: ApiService,
    private bsModalRef: BsModalRef,
    private spinnerService: SpinnerService,
    private authService: AuthService,
    private userService: UserService,
  ) {
  };

  ngOnInit(): void {
    this.getDealerList();
    this.getAssignedDealers(this.userInfo.username)
    this.showList();

    this.searchText.valueChanges
      .pipe(debounceTime(300), distinctUntilChanged())
      .subscribe(text => {
        this.q = text;
        this.showList();
      });
  }

  onAssignChangeSelect($event) {
    const bpNo = $event.target.value;
    const isChecked = $event.target.checked;


    if (isChecked === true) {
      if (bpNo !== '-1') {
        this.assignedList.push(bpNo);
      }
    } else {
      const index: number = this.assignedList.indexOf(bpNo)
      this.assignedList.splice(index, 1);
    }
  }

  onUnAssignChangeSelect($event) {
    const bpNo = $event.target.value;
    const isChecked = $event.target.checked;

    if (isChecked === true) {
      this.unassignedList.push(bpNo);
    } else {
      const index: number = this.unassignedList.indexOf(bpNo)
      this.unassignedList.splice(index, 1);
    }
  }

  getAssignedDealers(username) {
    this.apiService.user.getAssignedDealers(username)
      .subscribe((res: any[]) => {
        this.assignedDealers = res
      });
  }

  assignDealers() {
    let unAssign = { assignDealers: this.unassignedList }
    this.apiService.user.assignDealers(this.userInfo, unAssign)
      .subscribe((res: any[]) => {
        this.assign = res
        this.unassignedList = [];
        this.reload()
      });
  }

  unAssignDealers() {
    let assign = { unAssignDealers: this.assignedList }
    this.apiService.user.unAssignDealers(this.userInfo, assign)
      .subscribe((res: any[]) => {
        this.unAssign = res
        this.assignedList = [];
        this.reload()
      });
  }

  onPageEvent(pageEvent: PageEvent) {
    this.showList(pageEvent);
  }

  showList(pageEvent?: PageEvent) {
    this.spinnerService.start();
    this.unAssignedDealers = this.apiService.dealer.getUnAssignedDealers(pageEvent, this.q, this.query, this.userInfo.username)
      .pipe(finalize(() => this.spinnerService.stop()))
      .subscribe(res => {
        this.pagedResponse = res
        this.dealerData = res.docs.map((m) => {
          return m;
        })
      }, err => Utils.showError(err));


  }

  reload() {
    this.getAssignedDealers(this.userInfo.username)
    this.showList();
    this.userService.detailReload$.next(true);
  }

  close() {
    this.onClose.next(null);
    this.bsModalRef.hide();
  }

  changeDealer(e) {
    if (e && e.bpNo) {
      this.query = { $or: [{ bpNo: e.bpNo }, { hqBpNo: e.bpNo }] };
    } else {
      this.query = {};
    }
    this.showList();
  }

  getDealerList() {
    this.dealerSelectGroup = this.authService.getHQDealers();
  }
}
